// hook for pulling context plugins

import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchPluginsThunk } from 'store/plugin/plugin.thunk';

export type TValueTypeOption = {
  displayName: string;
  value: string;
};

export type TContextAttributeParameter = {
  index: number;
  key: string;
  valueType: string;
  valueKeys: string[];
  name: string;
  description: string;
  valueTypeOptions: TValueTypeOption[];
  isShowValue: boolean;
  isShowDisplayName: boolean;
};

export type TContextAttribute = {
  uid: string;
  id: string;
  valueType: string;
  valueTypeOptions: TValueTypeOption[];
  valueKeys: string[];
  defaultExpDuration: number;
  iconUrl: string;
  colour: string;
  name: string;
  description: string;
  parameters: TContextAttributeParameter[];
  performsExtraProcessing: boolean;
  extraProcessingAddress: string;
  isTenantScoped: boolean;
  isTimeContext: boolean;
  shouldBeSaved: boolean;
  isShowValue: boolean;
  isShowDisplayName: boolean;
  refreshDestination: {
    connectorInstanceId: string;
  };
  remapping: {
    from: object;
    to: object;
  };
  defaultValueSettings?: TDefaultValueSettings;
};

export type TDefaultValueSettings = {
  paramMatchingRules?: unknown;
  useDefaultValueIfNoParamMatch?: boolean;
  defaultValue?: {
    value?: string | number | boolean | null;
  };
};

export type TContextPlugin = {
  uid: string;
  id: string;
  tenantId: string;
  isReserved: boolean;
  refreshRate: number;
  supportedPlatforms: string[];
  provider: string;
  category: string;
  userScope: boolean;
  isSaRestricted: boolean;
  name: string;
  description: string;
  iconUrl: string;
  values: Record<string, TContextAttribute>;
  tenantConfig: {
    id: string;
    tenantId: string;
    contextPluginId: string;
    isEnabled: boolean;
    refreshRate: number;
  };
  dataSource: string;
  tenantAccess: object;
};

export default function usePlugins() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const plugins = useSelector((state: any) => state.plugin.plugins);
  const dispatch = useDispatch();
  // TODO: when we add proper pagination support, real loading states are needed
  // right now too many requests come in before plugins have updated in store
  const isInitialized = plugins;

  useEffect(() => {
    if (isInitialized) return;
    dispatch(fetchPluginsThunk());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    plugins,
    isInitialized,
  };
}
